/**
 * Vocabulário compartilhado por todo endpoint `/v1`.
 *
 * ── Uma fonte só ──────────────────────────────────────────────────────────
 *
 * As schemas em zod são a origem de três coisas: a validação em runtime, o
 * documento OpenAPI e os tipos que `apps/web` importa. Escrever OpenAPI à mão
 * produz documentação que mente a partir da terceira semana — é a armadilha
 * nomeada na B33 —, e manter tipo e validação separados produz a mesma mentira
 * com um passo a mais.
 *
 * O envelope de erro fica em `problema.ts`; data, dinheiro e versão, em
 * `valores.ts`; paginação, em `paginacao.ts`.
 */

import { z } from 'zod';

/** Identificador de tenant, usuário e demais entidades: UUID (§4). */
export const IdSchema = z.string().uuid();

/**
 * Os seis papéis da §13.2 e o Super Admin (ADR-0025), iguais aos slugs de
 * `core.roles`. O Super Admin aparece na sessão e no `/v1/me`, mas nunca é dado
 * pela tela de pessoas: a API o recusa ali, como recusa `operacao_cliqfy`.
 */
export const PapelSchema = z.enum([
  'agente',
  'vendedor',
  'gestor',
  'admin_tenant',
  'operacao_cliqfy',
  'sistema',
  'super_admin',
]);

export type Papel = z.infer<typeof PapelSchema>;

/** Escopo de visibilidade do vínculo (§13.1), como em `core.memberships`. */
export const CarteiraSchema = z.enum(['propria', 'time', 'unidade', 'tenant']);

export type Carteira = z.infer<typeof CarteiraSchema>;
